import React from "react";

const RemarksPopup = ({ remarksArray, onClose }) => {
  //   if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          maxWidth: "500px",
          width: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            borderBottom: "1px solid #e0e0e0",
            paddingBottom: "10px",
          }}
        >
          <h3 style={{ margin: 0, color: "#333" }}>Remarks History</h3>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#666",
              padding: "5px",
            }}
          >
            ×
          </button>
        </div>

        {remarksArray && remarksArray.length > 0 ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            {remarksArray.map((remark, index) => (
              <div
                key={remark._id || index}
                style={{
                  padding: "15px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "6px",
                  borderLeft: "4px solid #85da4f",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "8px",
                  }}
                >
                  <strong style={{ color: "#333", fontSize: "14px" }}>
                    {remark?.user?.fullName || "Unknown User"}
                  </strong>
                  <span style={{ color: "#666", fontSize: "12px" }}>
                    {new Date(remark.createdOn).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </span>
                </div>
                <p
                  style={{
                    margin: 0,
                    color: "#555",
                    lineHeight: "1.4",
                    fontSize: "14px",
                  }}
                >
                  {remark.remark}
                </p>
                <div style={{ marginTop: "5px" }}>
                  <small style={{ color: "#888", fontSize: "11px" }}>
                    {new Date(remark.createdOn).toLocaleTimeString("en-IN", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </small>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "40px 20px",
              color: "#666",
            }}
          >
            <p style={{ margin: 0, fontSize: "16px" }}>No remarks found</p>
          </div>
        )}

        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: "#85da4f",
              color: "white",
              border: "none",
              padding: "8px 20px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemarksPopup;
